<fieldset class="edit-tags__section">
  <legend>Tags</legend>
  <div class="edit-tags__section-content">
      <mat-checkbox #checkbox class="edit-tags__checkbox" *ngFor="let tag of tags" [checked]="isChecked(tag.tagId)" [id]="tag.tagId" (change)="checkBoxChanged($event)"> {{tag.displayName}}</mat-checkbox>
  </div>
</fieldset>
